module.exports = __webpack_public_path__ + "img/kulturminner.98e6deb5.jpg";